import createTemplate from "../../utils/createTemplate";

export const wrapperTemplate = createTemplate(`
<div
    aria-live="polite"
    class="slick-list draggable"
    style="position: relative; overflow: hidden; margin: 0; padding: 0;"
>
    <div
        class="slick-track"
        role="group"
        style="transform: translate3d(0, 0, 0); opacity: 1; position: relative; top: 0; left: 0; display: block;"
    >
    </div>
<div>`);

export const dotListTemplate = createTemplate(`
<ul class="slick-dots" role="tablist" style="display: block;"></ul>`);

export const dotItemTemplate = createTemplate(`
<li aria-hidden="true" role="presentation" aria-selected="true">
    <button type="button" data-role="none" role="button" aria-required="false" tabindex="-1"></button>
</li>`);
